import qs from 'query-string';

import IdentificationRequests, {
  IIdentificationRequest,
  IIdentificationRequestApi,
} from '@models/IdentificationRequests.model';

import { onboarding } from '@services';

interface IRequest {
  id?: string;
  threadId?: string;
}

const getIdentificationRequest = async ({
  id,
  threadId,
}: IRequest): Promise<IIdentificationRequest> => {
  const query = {
    id,
    threadId,
  };

  const queryString = qs.stringify(query);

  const { data: assets } = await onboarding.get<IIdentificationRequestApi>(
    `api/v1/file/irequest?${queryString}`,
  );

  return IdentificationRequests.fromApiModel(assets);
};

export { getIdentificationRequest };
